import React from 'react'
import { SVGIconProps } from '../types'
const SvgHorizontalSplit = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3 19h18v-6H3zm0-8h18V9H3zm0-6v2h18V5z" />
  </svg>
)
export default SvgHorizontalSplit
